module.exports = "/packs/media/images/brands/schwab-2a0782e23fbd523e6c7b34d593d04269.png";